<template>
  <div class="st-offers-actions">
    <StButton
      rectangular
      secondary
      @click="handleOpenChangeModal"
      :disabled="!userState.isAdmin"
    >
      <StIcon name="border-color" />
      Ändra abonnemang
    </StButton>
    <TableButton
      icon-name="st-delete"
      text="Ta bort"
      :disabled="!userState.isAdmin"
      @click="handleOpenRemoveModal"
    />
  </div>
  <RemoveOfferModal
    ref="removeModal"
    :offer-name="offer.offerName"
    :organization-number="offer.organizationNumber"
    :is-loading="removeIsLoading"
    :error-message="removeErrorMessage"
    @remove="removeOffer"
    @close="closeRemoveModal"
  />
  <ChangeSubscriptionModal
    ref="changeModal"
    :offer-name="offer.offerName"
    :organization-number="offer.organizationNumber"
    :subscription="offer.accountOfferSubscription"
    :is-loading="changeIsLoading"
    :error-message="changeErrorMessage"
    @save="changeSubscription"
    @close="closeChangeModal"
  />
  <ConfirmationModal
    ref="confirmationModal"
    title="Dina uppgifter har sparats!"
    status
    @close="closeConfirmationModal"
  />
</template>

<script setup>
import { StButton, StIcon } from "skanetrafiken";
import TableButton from "@/components/common/TableButton.vue";
import RemoveOfferModal from "@/components/modals/RemoveOfferModal.vue";
import ChangeSubscriptionModal from "@/components/modals/ChangeSubscriptionModal.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import { useModal } from "@/composables/useModal";
import Services from "@/services";
import { GENERIC_ERROR_MSG } from "@/constants";
import { ref } from "vue";
import { useUser } from "@/composables/useUser";

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
  onRemoved: Function,
  onUpdated: Function,
});

const removeModal = ref(null);
const [openRemoveModal, closeRemoveModal] = useModal(removeModal);
const removeIsLoading = ref(false);
const removeErrorMessage = ref("");
const changeModal = ref(null);
const [openChangeModal, closeChangeModal] = useModal(changeModal);
const confirmationModal = ref(null);
const [openConfirmationModal, closeConfirmationModal] =
  useModal(confirmationModal);
const changeIsLoading = ref(false);
const changeErrorMessage = ref("");
const { state: userState } = useUser();

const handleOpenRemoveModal = () => {
  removeErrorMessage.value = "";
  openRemoveModal();
};

const removeOffer = async () => {
  removeIsLoading.value = true;
  removeErrorMessage.value = "";

  try {
    await Services.Offers.DELETE.DELETE_ACCOUNT_OFFER({
      accountOfferId: props.offer.accountOfferId,
    });
    closeRemoveModal();
    props.onRemoved?.(props.offer);
  } catch (err) {
    removeErrorMessage.value = GENERIC_ERROR_MSG;
  } finally {
    removeIsLoading.value = false;
  }
};

const handleOpenChangeModal = () => {
  changeErrorMessage.value = "";
  openChangeModal();
};

const changeSubscription = async (subscription) => {
  changeIsLoading.value = true;
  changeErrorMessage.value = "";

  try {
    await Services.Offers.PUT.UPDATE_ACCOUNT_OFFER({
      accountOfferId: props.offer.accountOfferId,
      subscription,
    });
    closeChangeModal();
    props.onUpdated?.({
      ...props.offer,
      accountOfferSubscription: subscription,
    });
    openConfirmationModal();
  } catch (err) {
    changeErrorMessage.value = GENERIC_ERROR_MSG;
  } finally {
    changeIsLoading.value = false;
  }
};
</script>

<style scoped lang="scss">
@import "~skanetrafiken/dist/scss/main.scss";

.st-offers-actions {
  display: flex;
  align-items: center;
  gap: rem-calc(8);
  flex-direction: column;

  @include medium {
    flex-direction: row;
  }
}
</style>
